// Global Production API URL
export const API_LINK = 'https://api.learninghub.ind.in';

// export const API_LINK = 'http://localhost:5000';
 